import { render, staticRenderFns } from "./CreateCustomer.vue?vue&type=template&id=016e6866&scoped=true"
import script from "./CreateCustomer.vue?vue&type=script&lang=js"
export * from "./CreateCustomer.vue?vue&type=script&lang=js"
import style0 from "./CreateCustomer.vue?vue&type=style&index=0&id=016e6866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016e6866",
  null
  
)

export default component.exports